module.exports = __webpack_public_path__ + "img/tabbar_lightskin_2.19162eec.png";